<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "resourceIndex",
  data() {
    return {
      searchTxt: "",
    };
  },
};
</script>
<style lang="less" scoped>

</style>